export default __webpack_public_path__ + "static/media/placeholder_product.05195e3b.svg";